import styles from './styles/styles.scss';

export const TILE_SIZES = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    auto: 'auto',
} as const;

export const tileHeights = {
    [TILE_SIZES.small]: '152',
    [TILE_SIZES.medium]: '202',
    [TILE_SIZES.large]: '262',
    [TILE_SIZES.auto]: '262',
} as const;

export type TileSize = (typeof TILE_SIZES)[keyof typeof TILE_SIZES];

export const imageBackgroundColors = {
    whiteSmoke: styles.whiteSmoke,
} as const;

export type ImageBackgroundColor = keyof typeof imageBackgroundColors;
